import { Component, Input, OnInit } from '@angular/core';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';

@Component({
  selector: 'app-html-element',
  templateUrl: './html-element.component.html',
  styleUrls: ['./html-element.component.scss']
})
export class HtmlElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;

  constructor() { }

  ngOnInit(): void {
  }

  public getHtml(): string {
    return this.element?.label ?? '';
  }
}
